import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ObjectFieldEntity } from './object-field.entity';
import { PreferenceEntity } from './preference.entity';

@Index('_fk__object_field__id', ['fkObjectFieldId'], {})
@Index('_fk__preference__id', ['fkPreferenceId'], {})
@Entity('_preference_detail')
export class PreferenceDetailEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__preference__id',
		nullable: true,
		unsigned: true,
	})
	public fkPreferenceId!: number | null;

	@Column('varchar', { name: '_name', nullable: true, length: 64 })
	public name!: string | null;

	@Column('varchar', { name: '_label', nullable: true, length: 255 })
	public label!: string | null;

	@Column('text', { name: '_description', nullable: true })
	public description!: string | null;

	@Column('varchar', { name: '_type', nullable: true, length: 64 })
	public type!: string | null;

	@Column('int', {
		name: '_fk__object_field__id',
		nullable: true,
		unsigned: true,
	})
	public fkObjectFieldId!: number | null;

	@ManyToOne(
		() => PreferenceEntity,
		(preference) => preference.preferenceDetails,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk__preference__id', referencedColumnName: 'id' }])
	public fkPreference!: PreferenceEntity;

	@ManyToOne(
		() => ObjectFieldEntity,
		(objectField) => objectField.preferenceDetails,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: '_fk__object_field__id', referencedColumnName: 'id' }])
	public fkObjectField!: ObjectFieldEntity;
}
